<script setup>

</script>

<template>
  <div class="landingImage">

    <div class="flex flex-col gap-14 h-full justify-center sm:justify-between px-4 md:px-12 text-white py-12">

      <div class="flex items-center justify-center">
        <div class="text-center responsive-title-1 font-thin">
          Make an inquiry
        </div>
      </div>

        <div class="flex flex-col gap-3 text-center sm:mb-20">
          <p class="font-semibold responsive-body-small sm:responsive-body-xlarge leading-snug">
            Get in touch with us to help you plan the journey of your life.
          </p>
          <p class="font-semibold responsive-body-small sm:responsive-body-xlarge leading-snug">
            Whatever you wish, we can make it happen.
          </p>
          <p class="hidden sm:flex responsive-body-small sm:responsive-body-medium flex-col sm:flex-row items-center place-content-center gap-2">
            <span>Or you can send us an e-mail at:</span>
            <span class="flex items-center gap-1">
              <img src="@/assets/icons/email_white.png" alt="Email" class="h-3 w-4" />
              <a href="mailto:info@cosmosluxuryyachts.com" class="hover:underline whitespace-nowrap">info@cosmosluxuryyachts.com</a>
            </span>
          </p>
      </div>
    </div>
  </div>
</template>


<style scoped>
.landingImage {
  background-image: linear-gradient(to bottom, rgba(16, 10, 53, 0.7), rgba(16, 10, 53, 0)),
  url(@/assets/inquiry/Inquiry.jpg);
  background-size: cover;
  object-fit: contain;
  background-position: center;
  background-attachment: fixed;
  height: 90vh;
  max-height: 950px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  gap: 40px;
}

@media (max-width: 768px) {
  .landingImage {
    max-height: 474px;
    background-position: center;
  }
}

</style>
